import { Root } from "./Screen.style"

const Screen = ({ className, children }) => (
  <Root className={className}>{children}</Root>
)

export default Screen
